/**
 * Bill data stores load and grid import (net) as zero or negative kW. Charts show those
 * magnitudes as positive values above the axis.
 */
export function nonPositiveKwAsPositiveForChart(kw: number): number {
  return kw < 0 ? -kw : kw
}

export function nonPositiveKwSeriesAsPositiveForChart(values: readonly number[]): number[] {
  return values.map(nonPositiveKwAsPositiveForChart)
}
